import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  exercisesWrapper: {},
  headerTooltip: {
    [theme.breakpoints.up('md')]: {
      marginRight: theme.spacing(2),
    },
  },
  tabsContent: {},

  exercisesAddButton: {
    minWidth: 'unset',
    fontWeight: 600,
    padding: 0,
    height: '40px',
    width: '40px',
    borderRadius: '50%',
  },
}));
